import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import useServicesPerUnitPerYearChart from './hooks/useServicesPerUnitPerYear';

export const ServicesPerUnitPerYearChart = () => {
    const { series, subtitles } = useServicesPerUnitPerYearChart();

    return (
        <SimpleBars
            title={`Atendimentos por Unidade (Top 5)`}
            subtitles={subtitles}
            horizontal
            values={series}
        />
    );
};
